var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AssetList',{attrs:{"all":_vm.isAll,"assets":_vm.assets}})}
var staticRenderFns = []

export { render, staticRenderFns }